import {
  CREATE_CHALLENGE,
  UPDATE_CHALLENGE,
  UNLOAD_CHALLENGE,
  CHALLENGE_FETCHED_SUCCESS,
  RESET_CHALLENGE,
} from '../constants/actionTypes';

const initialState = {
  challenges: [],
  message: '',
  pager: {
    current: 1,
    pageSize: 15,
    total: 0,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CREATE_CHALLENGE:
    case UPDATE_CHALLENGE:
      return {
        ...state,
        message: action.payload.msg,
      };

    case RESET_CHALLENGE:
      return {
        ...state,
        message: '',
      };

    case CHALLENGE_FETCHED_SUCCESS:
      return {
        ...state,
        challenges: action.payload.challenges.map((item) => {
          const newItem = { ...item, id: item.id };
          return newItem;
        }),
        pager: action.payload.pager,
      };

    case UNLOAD_CHALLENGE:
      return initialState;

    default:
      return state;
  }
};
